<script setup>
import { useBroadcastChannel } from '@vueuse/core';
import { watch, provide, ref } from 'vue';
import { useAuthStore } from './stores/auth';
import { useRoute } from 'vue-router'
import { computed } from 'vue'
import MainLayout from '@/layouts/mainLayout.vue'
import AuthLayout from './layouts/authLayout.vue';
import { useIdleCounter } from '@/composables/useTimeLogout'

const authStore = useAuthStore();
const vigencia = ref(null);
const seccionPresupuestal = ref(null);

const {
  isSupported,
  data,
  post,
  error,
} = useBroadcastChannel({ name: 'logout-channel' })

watch(data, (newValue) => {
    if (newValue && newValue !== "") {
      console.log(newValue)
      authStore.logout();
      data.value= null;
    }
})

// Escoge layout usar

const route = useRoute()

const layoutComponent = computed(() => {
  const layout = route.meta.layout || 'AuthLayout'
  return {
    MainLayout,
    AuthLayout
  }[layout]
})
// Detectar si hay movimiento de mouse
useIdleCounter()
//
// titulo de la pagina
const pageTitle = computed(() => {
  return `${route.meta.title}`
})
// Verifica la vigencia
watch(authStore, () => {
  if (layoutComponent.value !== AuthLayout) {
    vigencia.value = authStore.vigencia?.id ?? null;
    seccionPresupuestal.value = authStore.seccionPresupuestal?.id ?? null;
  }
})

provide('vigencia', vigencia);
provide('seccionPresupuestal', seccionPresupuestal);
provide('pageTitle', pageTitle)

</script>
<template>
  <component :is="layoutComponent">
    <template #main>
      <router-view v-if="layoutComponent === AuthLayout || (vigencia && seccionPresupuestal)" />
    </template>
  </component>
</template>